import { z } from 'zod';

import type { TargetingIabCategory } from './model';

export const namedTargetingEntitySchema = z.looseObject({
  id: z.string(),
  name: z.string(),
});

export const targetingDeviceTypeSchema = z
  .looseObject({
    id: z.string().optional(),
    name: z.string(),
    deviceTypeId: z.string(),
  })
  .transform((deviceType) => ({
    ...deviceType,
    id: deviceType.id ?? deviceType.deviceTypeId,
  }));

export const targetingLanguageSchema = z
  .looseObject({
    id: z.string().optional(),
    name: z.string(),
    code: z.string().optional(),
    isoCode2: z.string().optional(),
    isoCode3: z.string().optional(),
  })
  .transform((language) => ({
    ...language,
    id: language.id ?? language.isoCode3 ?? language.isoCode2 ?? language.name,
    code: language.code ?? language.isoCode3 ?? language.isoCode2,
  }));

const targetingIabCategorySchema = z
  .looseObject({
    id: z.string(),
    name: z.string().optional(),
    title: z.string().optional(),
    titlev2: z.string().optional(),
    code: z.string().optional(),
  })
  .transform((category) => ({
    ...category,
    name: category.name ?? category.titlev2 ?? category.title ?? category.id,
  }));

export const targetingIabCategoriesSchema = z
  .union([
    z.array(targetingIabCategorySchema),
    z.looseObject({ content: z.array(targetingIabCategorySchema) }),
  ])
  .transform((payload: TargetingIabCategory[] | { content: TargetingIabCategory[] }) =>
    Array.isArray(payload) ? payload : payload.content,
  );
